export default {
  namespaced: true,
  state: () => ({
    topicIdData: [],
    productList:{},
    shoucangList:{}
  }),
  mutations: {
    topicId(state, payload) {
      state.topicIdData = payload
      sessionStorage.setItem('topicIdData', JSON.stringify(payload))
    },
    setProductList(state, payload){
      state.productList = payload
      sessionStorage.setItem('productList', JSON.stringify(payload))
      console.log(2222,payload);
    },
    setShoucangList(state, payload){
      state.shoucangList = payload
      sessionStorage.setItem('shoucangList', JSON.stringify(payload))
      console.log(333,payload);
    }
  }

}
